<div>
    <div v-if="!rate_rows.length" class="border rounded-2 text-center py-5 px-3">
        <p class=" fw-semibold mb-1">No tariff rates found</p>
        <p class=" text-xs mb-0">This tariff book does not currently return any rate records to edit.</p>
    </div>

    <div v-if="latest_rate" class="d-flex flex-column gap-3">
        <details class="border rounded-2 bg-black bg-opacity-25 overflow-hidden" open>
            <summary class="list-unstyled d-flex justify-content-between align-items-center gap-2 p-3 cursor-pointer">
                <div class="d-flex flex-column gap-1">
                    <span class=" fw-semibold text-xs">Latest Version</span>
                    <span class="text-secondary text-xs">{{ get_rate_version_label(latest_rate) }}</span>
                </div>
                <span class="badge rounded-pill text-bg-primary text-xs fw-semibold d-inline-flex align-items-center gap-1">
                    <i class="bi bi-pencil-square" aria-hidden="true"></i>
                    Editable
                </span>
            </summary>

            <div class="px-3 pb-3 border-top border">
                <div class="row g-2 my-1">
                    <div
                        v-for="field in get_detail_fields(latest_rate)"
                        :key="`${latest_rate.id}-${field.label}`"
                        class="col-12 col-md-6"
                    >
                        <label class="form-label  text-xs fw-semibold mb-1">
                            {{ field.label }}
                            <span class="text-secondary fw-normal">(locked)</span>
                        </label>
                        <div class="form-control form-control-sm bg-light text-secondary border-secondary rounded-3 fw-bold text-xs">
                            {{ field.value }}
                        </div>
                    </div>
                </div>

                <div class="row g-2 my-1">
                    <div class="col-12 col-md-6">
                        <label class="form-label  text-xs fw-semibold mb-1">Effective start date</label>
                        <input
                            :value="latest_rate.effective_from"
                            type="date"
                            class="form-control form-control-sm bg-light  border-secondary rounded-3 text-xs"
                            required
                            @input="$emit('update-effective', latest_rate, 'effective_from', $event.target.value)"
                        />
                    </div>

                    <div class="col-12 col-md-6">
                        <label class="form-label  text-xs fw-semibold mb-1">Effective end date</label>
                        <input
                            :value="latest_rate.effective_to"
                            type="date"
                            class="form-control form-control-sm bg-light  border-secondary rounded-3 text-xs"
                            @input="$emit('update-effective', latest_rate, 'effective_to', $event.target.value)"
                        />
                    </div>
                </div>

                <div class="d-flex justify-content-between align-items-center gap-2 mt-3 mb-2">
                    <h6 class=" text-uppercase fw-bold text-xs mb-0">Charge Components</h6>
                    <span class="badge rounded-pill text-bg-primary text-xs fw-semibold">Latest only</span>
                </div>

                <div class="row g-2">
                    <div
                        v-for="metric in get_metric_rows(latest_rate)"
                        :key="`${latest_rate.id}-${metric.key}`"
                        class="col-12 col-md-6"
                    >
                        <div class="border-primary border-opacity-50 rounded-3 p-2 h-100 bg-black bg-opacity-25">
                            <label class="form-label  text-xs fw-semibold mb-1">
                                {{ metric.key }}
                                <span class="text-primary fw-normal">(latest version)</span>
                            </label>
                            <input
                                :value="metric.value"
                                type="number"
                                step="0.01"
                                class="form-control form-control-sm bg-transparent  border-primary rounded-3 fw-bold text-xs"
                                @input="$emit('update-metric', latest_rate, metric.key, $event.target.value)"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </details>

        <details
            v-for="rate in historical_rates"
            :key="`history-${rate.id}`"
            class="border rounded-2 bg-black bg-opacity-25 overflow-hidden"
        >
            <summary class="list-unstyled d-flex justify-content-between align-items-center gap-2 p-3 cursor-pointer">
                <div class="d-flex flex-column gap-1">
                    <span class=" fw-semibold text-xs">{{ get_rate_version_label(rate) }}</span>
                    <span class="text-secondary text-xs">Previous charge components</span>
                </div>
            <span class="badge rounded-pill text-bg-danger text-xs fw-semibold d-inline-flex align-items-center gap-1">
                    <i class="bi bi-lock" aria-hidden="true"></i>
                    Read only
                </span>
            </summary>

            <div class="px-3 pb-3 border-top border">
                <div class="row g-2 my-1">
                    <div
                        v-for="metric in get_metric_rows(rate)"
                        :key="`history-${rate.id}-${metric.key}`"
                        class="col-12 col-md-6"
                    >
                        <div class="border rounded-3 p-2 h-100">
                            <label class="form-label  text-xs fw-semibold mb-1">
                                {{ metric.key }}
                            </label>
                            <div class="form-control form-control-sm bg-light text-secondary border-secondary rounded-3 fw-bold text-xs">
                                {{ metric.value }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </details>
    </div>
</div>
